import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, role }) {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <Loader2 className="animate-spin text-gold" strokeWidth={1.5} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role && user.role !== "admin") {
    return <Navigate to={user.role === "partner" ? "/partner" : "/dashboard"} replace />;
  }
  if (role === "admin" && user.role !== "admin") {
    return <Navigate to={user.role === "partner" ? "/partner" : "/dashboard"} replace />;
  }
  return children;
}
